var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 10.0003C10.8334 10.4606 10.4603 10.8337 10.0001 10.8337C9.53984 10.8337 9.16675 10.4606 9.16675 10.0003C9.16675 9.54009 9.53984 9.16699 10.0001 9.16699C10.4603 9.16699 10.8334 9.54009 10.8334 10.0003Z",
    stroke: "#808897",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83341 10.0003C5.83341 10.4606 5.46032 10.8337 5.00008 10.8337C4.53984 10.8337 4.16675 10.4606 4.16675 10.0003C4.16675 9.54009 4.53984 9.16699 5.00008 9.16699C5.46032 9.16699 5.83341 9.54009 5.83341 10.0003Z",
    stroke: "#808897",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 10.0003C15.8334 10.4606 15.4603 10.8337 15.0001 10.8337C14.5398 10.8337 14.1667 10.4606 14.1667 10.0003C14.1667 9.54009 14.5398 9.16699 15.0001 9.16699C15.4603 9.16699 15.8334 9.54009 15.8334 10.0003Z",
    stroke: "#808897",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three-dots.d2fa457e93f5e761882ebd3c0ed5af57.svg";
export { ForwardRef as ReactComponent };